import util from '@bmp-vue/core/api/util';

const controller = 'CallbackPropostaPortal';
export default Object.assign({}, util.GetCrud(controller, null), {
  filtrarAcoesCallback: function (acao, situacoes) {
    switch (acao) {
      case 1:
        return situacoes.filter((item) => {
          const status = [6, 7];
          return status.includes(item.value);
        });
      case 2:
        return situacoes.filter((item) => {
          const status = [2, 6, 7, 8, 9, 10];
          return status.includes(item.value);
        });
      case 3:
        return situacoes.filter((item) => {
          const status = [2, 5];
          return status.includes(item.value);
        });
      case 4:
        return situacoes.filter((item) => {
          const status = [2, 6, 7, 8, 9, 10];
          return status.includes(item.value);
        });
      case 5:
        return situacoes.filter((item) => {
          const status = [1];
          return status.includes(item.value);
        });
      case 6:
        return situacoes.filter((item) => {
          const status = [5, 8];
          return status.includes(item.value);
        });
      case 7:
        return situacoes.filter((item) => {
          const status = [2];
          return status.includes(item.value);
        });
    }
  },
});
